import { Box, Grid } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { CircularProgress, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { getAllPackages } from "services/PackageServices/packageService";
import { planConfig } from "StaticDataFiles/planConfig";
import PlanCard from "./PlanCard";
import BuyNowPopup from "./ProviderOnboardingComponents/BuyNowPopup";

const useStyles = makeStyles(() => ({
    root: {
        padding: "38px 16px",
        background: "#f9fafb",
    },
    grid: {
        maxWidth: 1200,
        justifySelf: 'center',
        // margin: "0 auto",
    },
    center: {
        paddingTop: '10%',
        paddingBottom: '10%',
        textAlign: 'center',
    }
}));

const plans = [
    {
        id: 1,
        title: "Starter",
        subtitle: "Best for small batches",
        price: 499,
        PackageDurationInDays: 60,
        features: ["5 Tests", "Basic Analytics", "Email Support"],
    },
    {
        id: 2,
        title: "Basic",
        subtitle: "Growing institutes",
        price: 999,
        PackageDurationInDays: 90,
        features: ["15 Tests", "Advanced Analytics", "Priority Support"],
    },
    {
        id: 3,
        title: "Pro",
        subtitle: "Most Popular",
        price: 1999,
        PackageDurationInDays: 180,
        features: ["Unlimited Tests", "Full Analytics", "WhatsApp Support"],
        featured: true,
    },
    {
        id: 4,
        title: "Enterprise",
        subtitle: "Custom solution",
        price: 20000,
        PackageDurationInDays: 240,
        features: ["Unlimited Everything", "Dedicated Manager", "API Access"],
    },
];

const Packages = () => {
    const classes = useStyles();
    const [open, setOpen] = useState(false);
    const [selectedPlan, setSelectedPlan] = useState(null);

    const [plans, setPlans] = useState([]);
    const [loading, setLoading] = useState(true);

    const handleBuy = (plan) => {
        setSelectedPlan(plan);
        setOpen(true);
    };

    useEffect(() => {
        fetchPackages();
    }, []);

    const fetchPackages = async () => {
        setLoading(true);
        const apiPlans = await getAllPackages();

        // Step 1: keep only packages configured in static file
        const configuredPackageIds = planConfig.map(c => c.packageId);

        const filteredPlans = apiPlans.filter(pkg =>
            configuredPackageIds.includes(pkg.packageId)
        );

        // Step 2: merge filtered API data with config
        const mergedPlans = filteredPlans.map((pkg) => {
            const config = planConfig.find(
                (c) => c.packageId === pkg.packageId
            );

            return {
                id: pkg.packageId,
                title: pkg.packageName,
                price: pkg.amount,
                subtitle: config.subtitle,
                features: config.features,
                featured: config.featured,
                PackageDurationInDays: config.PackageDurationInDays,
            };
        });

        // Optional: sort by config order
        mergedPlans.sort((a, b) =>
            configuredPackageIds.indexOf(a.id) -
            configuredPackageIds.indexOf(b.id)
        );

        setPlans(mergedPlans);
        setLoading(false);
    };


    if (loading) {
        return (
            <div className={classes.center}>
                <CircularProgress />
                <Typography>Loading packages...</Typography>
            </div>
        );
    }

    return (
        <>
            <div className={classes.root}>
                <Box sx={{ textAlign: 'center', mb: 4 }}>
                    <Typography
                        sx={{
                            mb: 2,
                            fontWeight: 700,
                            fontFamily: 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
                            color: '#0f1a24',
                            fontSize: '2.25rem',
                            lineHeight: '2.5rem'
                        }}>
                        Choose Your Perfect Plan
                    </Typography>
                    <Typography variant="h6" color="text.secondary"
                        sx={{
                            maxWidth: '800px',
                            mx: 'auto',
                            fontFamily: 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
                            color: '#65758b',
                            fontWeight: '400',
                            fontSize: '0.98rem',
                            lineHeight: '1.625rem',
                            color: '#6c7993',
                            textTransform: 'none'
                        }}>
                        Flexible solutions for every institute — pick the plan that fits your needs.
                    </Typography>
                </Box>
                <Grid container spacing={3} className={classes.grid}>
                    {plans.map((plan) => (
                        <Grid item xs={12} sm={6} md={4} key={plan.id}>
                            <PlanCard plan={plan} onBuy={handleBuy} />
                        </Grid>
                    ))}
                </Grid>
            </div>

            <BuyNowPopup
                open={open}
                onClose={() => setOpen(false)}
                plan={selectedPlan}
            />
        </>
    );
};

export default Packages;
